import colors from './colors';


const baseDiv = Object.freeze({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: 28,
    boxSizing: 'border-box'
});

const baseSvg = Object.freeze({
    fill: 'none'
});

const basePath = Object.freeze({
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
});

// styles for the svg and path, based on size; used by EmbeddedIcon
export const iconStyle = Object.freeze({
    xs: {
        svg: {
            ...baseSvg,
            height: 12,
            width: 12
        },
        path: {
            ...basePath,
            strokeWidth: 2
        }
    },
    sm: {
        svg: {
            ...baseSvg,
            height: 16,
            width: 16
        },
        path: {
            ...basePath,
            strokeWidth: 2
        }
    },
    md: {
        svg: {
            ...baseSvg,
            height: 20,
            width: 20
        },
        path: {
            ...basePath,
            strokeWidth: 2
        }
    },
    lg: {
        svg: {
            ...baseSvg,
            height: 24,
            width: 24
        },
        path: {
            ...basePath,
            strokeWidth: 2
        }
    },
    xl: {
        svg: {
            ...baseSvg,
            height: 28,
            width: 28
        },
        path: {
            ...basePath,
            strokeWidth: 2
        }
    }
});

// Div styles for the FeedbackIcon background specifically
export const feedbackIconDivStyle = Object.freeze({
    xs: {
        ...baseDiv,
        width: 24,
        height: 24,
        padding: 2,
        borderWidth: 2
    },
    sm: {
        ...baseDiv,
        width: 32,
        height: 32,
        padding: 3,
        borderWidth: 3
    },
    md: {
        ...baseDiv,
        width: 40,
        height: 40,
        padding: 4,
        borderWidth: 4
    },
    lg: {
        ...baseDiv,
        width: 48,
        height: 48,
        padding: 6,
        borderWidth: 6
    },
    xl: {
        ...baseDiv,
        width: 56,
        height: 56,
        padding: 8,
        borderWidth: 8
    }
});

// Colors for the background and icon of FeedbackIcons
export const feedbackIconColor = Object.freeze({
    light: {
        primary: {
            primary: {
                div: {
                    background: colors.primary100,
                    borderColor: colors.primary50,
                    borderStyle: 'solid'
                },
                icon: colors.primary600
            },
            gray: {
                div: {
                    background: colors.coolGray100,
                    borderColor: colors.coolGray50,
                    borderStyle: 'solid'
                },
                icon: colors.coolGray600
            },
            error: {
                div: {
                    background: colors.red100,
                    borderColor: colors.red50,
                    borderStyle: 'solid'
                },
                icon: colors.red600
            },
            warning: {
                div: {
                    background: colors.orange100,
                    borderColor: colors.orange50,
                    borderStyle: 'solid'
                },
                icon: colors.orange600
            },
            success: {
                div: {
                    background: colors.green100,
                    borderColor: colors.green50,
                    borderStyle: 'solid'
                },
                icon: colors.green600
            }
        },
        secondary: {
            primary: {
                div: {
                    background: colors.primary100
                },
                icon: colors.primary600
            },
            gray: {
                div: {
                    background: colors.coolGray100
                },
                icon: colors.coolGray600
            },
            error: {
                div: {
                    background: colors.red100
                },
                icon: colors.red600
            },
            warning: {
                div: {
                    background: colors.orange100
                },
                icon: colors.orange600
            },
            success: {
                div: {
                    background: colors.green100
                },
                icon: colors.green600
            }
        }
    },
    dark: {
        primary: {
            primary: {
                div: {
                    background: colors.primary700,
                    borderColor: colors.primary800,
                    borderStyle: 'solid'
                },
                icon: colors.primary50
            },
            gray: {
                div: {
                    background: colors.neutralGray500,
                    borderColor: colors.neutralGray600,
                    borderStyle: 'solid'
                },
                icon: colors.neutralGray50
            },
            error: {
                div: {
                    background: colors.red700,
                    borderColor: colors.red800,
                    borderStyle: 'solid'
                },
                icon: colors.red50
            },
            warning: {
                div: {
                    background: colors.orange700,
                    borderColor: colors.orange800,
                    borderStyle: 'solid'
                },
                icon: colors.orange50
            },
            success: {
                div: {
                    background: colors.green700,
                    borderColor: colors.green800,
                    borderStyle: 'solid'
                },
                icon: colors.green50
            }
        },
        secondary: {
            primary: {
                div: {
                    background: colors.primary600
                },
                icon: colors.primary50
            },
            gray: {
                div: {
                    background: colors.neutralGray600
                },
                icon: colors.neutralGray50
            },
            error: {
                div: {
                    background: colors.red600
                },
                icon: colors.red50
            },
            warning: {
                div: {
                    background: colors.orange600
                },
                icon: colors.orange50
            },
            success: {
                div: {
                    background: colors.green600
                },
                icon: colors.green50
            }
        }
    }
});